// eslint-disable-next-line import/no-extraneous-dependencies
import Model from '@/models/Model.js';

export default class TermScheduleCourseModel extends Model {
    static entity = 'term_schedule_course_models';

    static modelName = 'Course';

    static fields() {
        return {
            id: this.number(null),
            title: this.attr(null),

            ...super.fields(),
        };
    }
}
